import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=23a87c88&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=23a87c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a87c88",
  null
  
)

export default component.exports